import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Environment } from './environments/environment';
import { EnvironmentService } from 'src/app/shared/services/environment.service';

const environmentService = new EnvironmentService();
const environment = new Environment(environmentService);

environment
  .init()
  .then(async () => {
    if (environment.production) {
      enableProdMode();
    }
    const { AppModule } = await import('./app/app.module');
    // Pass the initialized environment to AppModule
    platformBrowserDynamic([{ provide: environment, useValue: environment }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((error) => {
    console.error('Failed to initialize environment:', error);
  });
